__turbopack_context__.v({
  "buttons": "HgOlVa_buttons",
});
